export type Constructor<T extends Object> = new (...args: Array<any>) => T;

export interface Sorting {
    field: string;
    direction: SortDirection;
}

export enum SortDirection {
    Asc = 'ASC',
    Desc = 'DESC',
}

export enum Platform {
    IOS = 'IOS',
    GOOGLE = 'GOOGLE',
    AMAZON = 'AMAZON',
}

export enum MediationEngine {
    APPODEAL = 'APPODEAL',
    APPLOVIN_MAX = 'APPLOVIN_MAX',
    BIDON = 'BIDON',
    IRON_SOURCE = 'IRON_SOURCE',
}

export interface Theme {
    defaultSavedReport: string;
    chartsDefaults: {
        topLimit: number;
        hideEmptySeries: boolean;
        showMissingPoints: boolean;
    };
    selectedTheme: {
        theme: ThemeType;
        popupShown: boolean;
    };
    defaultMainPage: {
        page: DefaultMainPage;
        popupShown: boolean;
    };
    themeMode: string;
}

export enum ThemeType {
    CLASSIC = 'CLASSIC',
    NEW = 'NEW',
}

export enum DefaultMainPage {
    MONETIZATION = 'MONETIZATION',
    OVERVIEW = 'OVERVIEW',
    REPORTS = 'REPORTS',
}
